import { useCallback } from 'react';
import { CampaignType } from '@mm/state/model/CampaignsModel';
import { CampaignOverviewItemType } from '@mm/state/model/CampaignOverviewModel';

export const useAutomationStatus = () => {
  const get = useCallback(
    (automation?: CampaignType | CampaignOverviewItemType) => {
      const active = automation && automation.active;
      const cancelled = automation && automation.status === 'canceled';
      const paused = automation && automation.status === 'paused';

      return {
        active,
        cancelled,
        paused,
      };
    },
    [],
  );

  const format = useCallback(
    (automation?: CampaignType | CampaignOverviewItemType) => {
      const active = !!(automation && automation.active);
      const cancelled = !!(automation && automation.status === 'canceled');
      const paused = !!(automation && automation.status === 'paused');

      switch (true) {
        case cancelled:
          return 'Cancelled';
        case paused:
          return 'Paused';
        case active:
          return 'Active';
        default:
          return 'Draft';
      }
    },
    [],
  );

  return {
    get,
    format,
  };
};
